import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import DialogUtils from '@/utils/dialogUtils'
import ParticlesUtils from '@/utils/particlesUtils'
import VueUtils from '@/utils/vueUtils'
import EventsUtils from '@/utils/eventsUtils'
import ReleaseNotesDialog from '@/components/ReleaseNotesDialog'
import Package from '~/package.json'
import AsyncUtils from '@/utils/asyncUtils'

async function migrate ()
{
    const fromVersion = LocalStorageUtils.lastInstalledVersion
    const toVersion = Package.version
    
    if (fromVersion == toVersion) return console.log('Version has not changed, no migration.')
    
    if (fromVersion) showNewReleaseBubble(toVersion)
    await executeMigrationScript(fromVersion, toVersion)

    LocalStorageUtils.lastInstalledVersion = Package.version
}

async function showNewReleaseBubble (version)
{
    const releaseNotes = require('~/static/release_notes.json').find(r => r.version == version)
    if (!releaseNotes) return console.warn('No release notes found for version', version)
    if (!Array.isArray(releaseNotes.notes) || releaseNotes.notes.length == 0) return console.warn('Version', version, 'is has no notes in release notes')

    const showReleaseNotes = (e, bubble) =>
    {
        app.$ga.event('release_notes_bubble', 'click:read_notes', version)
        
        bubble.close()
        VueUtils.createComponent(ReleaseNotesDialog, { release: releaseNotes })
    }

    await EventsUtils.onSplashscreenHidden()
    
    app.$ga.event('release_notes_bubble', 'shown', version)
    
    if (cordova.platformId == 'browser')
    {
        await AsyncUtils.sleep(500)
    }
    DialogUtils.showChatBubble({ message: `${EnvironmentUtils.cityName} vient d'être mis à jour ! Souhaitez-vous savoir ce qui a changé ?`,
    buttons: [{label: 'Oui, ça m\'intéresse', type: 'primary', action: showReleaseNotes}, {label: 'Non merci'}], showCloseButton: false })
    
    for (let i = 0; i < 100; i++) ParticlesUtils.createParticle({ duration: [0, 4000], delay: [0, 200] })
    for (let i = 0; i < 7; i++) ParticlesUtils.createParticle({ size: [50, 100], duration: [0, 3000], delay: [200, 600], text: ['😱', '🎁'] })
}

async function executeMigrationScript (fromVersion, toVersion)
{
    if (toVersion == '1.0.6' && fromVersion)
    {
        await reloadCityManifest()
    }
    if (toVersion == '1.0.8' && fromVersion)
    {
        await reloadCityManifest()
    }
    if (toVersion == '1.0.10' && fromVersion == '1.0.9')
    {
        const settings = LocalStorageUtils.notificationSettings
        settings.notifiedOnNewReport = !!LocalStorageUtils.token
        LocalStorageUtils.notificationSettings = settings
    }
    if (fromVersion && fromVersion.split('.')[2] < 11)
    {
        LocalStorageUtils.observables.lastNotificationSeen = null
    }
    if (toVersion == '1.0.13' && fromVersion)
    {
        const localTags = LocalStorageUtils.notificationSettings
        console.log('Migrating local storage tags to server', localTags)
        try
        {
           // await UsersServices.updateUser(EnvironmentUtils.cityId, {tags: localTags})
        }
        catch (e) { console.log(e) }
    }

    console.log('Migration', fromVersion, '->', toVersion, 'finished')
}

async function reloadCityManifest ()
{
    console.log('[Update Migration] Reloading city manifest..')
    LocalStorageUtils.cityManifest = null
    await LocalStorageUtils.fetchCityManifest(EnvironmentUtils.envCityId)
}


export default { migrate, showNewReleaseBubble }


// WEBPACK FOOTER //
// ./src/utils/updateMigrationUtils.js